import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { SavingsProductListView } from './views/SavingsProductListView';

export const savingsProductSettingsRoutes: RouteObject[] = [
    {
        path: '/admin/products/savings',
        element: <SavingsProductListView />,
        errorElement: <ErrorBoundary />,
    },
];
